import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

import styles from "./ConsumableBoxes.module.css";
import "swiper/css";

import { GoDeeperConsumableIcon } from "../../GoDeeperIcon";
import { useAlertContext } from "@/context/AlertContext";
import Alert from "@/components/shared/Alerts/Alert";
import { Mixpanel } from "@/helpers/mixpanel";
import { useAuth } from "@/context/AuthContext";

export default function ConsumableBoxes() {
  const { user } = useAuth();

  const [mySwiperRef, setMySwiperRef] = useState<any>(null);
  const [index, setIndex] = useState<number>(0);

  const premiumPrice = useSelector(
    (state: RootState) => state.appInfo.premiumLocalizedPrice
  );
  const consumableSmallPrice = useSelector(
    (state: RootState) => state.appInfo.consumableSmallLocalizedPrice
  );
  const consumableMediumPrice = useSelector(
    (state: RootState) => state.appInfo.consumableMediumLocalizedPrice
  );

  useEffect(() => {
    try {
      if (user?.uid) {
        window.Android?.logIntoRevenueCat(user.uid);
      }
      window.Android?.getPremiumPrice();
      window.Android?.getConsumableSmallPrice();
      window.Android?.getConsumableMediumPrice();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const mapped = [
    <ConsumableBox
      key={0}
      numberOfMessagesText="20 messages"
      pricePerMessage="$0.20/message"
      priceText={`Get for ${consumableSmallPrice}`}
    />,
    <ConsumableBox
      key={1}
      numberOfMessagesText="100 messages"
      pricePerMessage="$0.12/message"
      priceText={`Get for ${consumableMediumPrice}`}
      stickerText="SAVE 40%"
    />,
    <ConsumableBox
      key={2}
      numberOfMessagesText="1 Year"
      pricePerMessage="Includes unlimited messages"
      priceText={`Get for ${premiumPrice}`}
      stickerText="Unlimited messages"
    />,
  ].map((c, i) => {
    return <SwiperSlide key={i}>{c}</SwiperSlide>;
  });

  const mappedCircles = [0, 1, 2].map((c) => {
    return (
      <div
        onClick={() => {
          setIndex(c);
          mySwiperRef?.slideTo(c);
        }}
        style={index === c ? { opacity: "1" } : {}}
        className={styles.circle}
        key={c}
      ></div>
    );
  });

  return (
    <div className={styles.wrapperMain}>
      <Swiper
        min-height={200}
        autoHeight={true}
        slidesPerView={1}
        touchReleaseOnEdges={true}
        scrollbar={{ draggable: true }}
        threshold={1}
        onSwiper={setMySwiperRef}
        onSlideChange={(e) => {
          setIndex(e.activeIndex);
        }}
      >
        {mapped}
      </Swiper>
      <div className={styles.circlesWrapper}>{mappedCircles}</div>
    </div>
  );
}

type Props = {
  numberOfMessagesText: string;
  pricePerMessage: string;
  priceText: string;
  stickerText?: string;
};

export function ConsumableBox(props: Props) {
  const { setAlertComponent } = useAlertContext();
  const { user } = useAuth();

  function onClick() {
    try {
      if (props.pricePerMessage === "$0.20/message") {
        //small buy
        return window.Android?.buySmallConsumable();
      }

      if (props.pricePerMessage === "$0.12/message") {
        return window.Android?.buyMediumConsumable();
      }

      if (props.pricePerMessage === "Includes unlimited messages") {
        return window.Android?.initiatePurchase();
      }
    } catch (error) {
      return setAlertComponent(
        <Alert
          type="warning"
          buttonText="Notify me"
          onButtonClick={() => {
            Mixpanel?.track("Chatbot | Notify me CTA clicked", {}, user?.uid);
          }}
          message="Please update the app in order to purchase!"
          elementName="Alert"
        />,
        3000
      );
    }
  }
  return (
    <div onClick={() => onClick()} className={styles.main}>
      {props.stickerText && (
        <div className={styles.stickerDiv}>
          <p className={styles.sticketText}>{props.stickerText}</p>
        </div>
      )}
      <div className={styles.wrapper}>
        <h3 className={styles.title}>{props.numberOfMessagesText}</h3>
        {props.numberOfMessagesText === "1 Year" && (
          <p className={styles.dimensionalPlusText}>
            Dimensional <span className={styles.dimensionalPlus}>Plus</span>
          </p>
        )}
        <div className={styles.iconDiv}>
          <GoDeeperConsumableIcon />
        </div>
        <p className={styles.pricePerMessage}>{props.pricePerMessage}</p>
        <button className={styles.btn}>{props.priceText}</button>
      </div>
    </div>
  );
}
